<div class="notification-container" *ngIf="showUi()">
  <div class="notification-header">
    <h2>{{"GENERAL.NOTIFICATIONS" | translate}}</h2>
    <div class="actions-container">
      <div class="tabs">
        <button class="tab" [class.active]="activeTab === 'all'" (click)="setActiveTab('all')">{{"GENERAL.ALL" | translate}}</button>
        <button class="tab" [class.active]="activeTab === 'unread'" (click)="setActiveTab('unread')">{{"GENERAL.UNREAD" | translate}}</button>
      </div>
      <div class="header-actions">
        <button class="see-all-btn" (click)="markAllAsRead()">{{"GENERAL.MARK_ALL_READ" | translate}}</button>
      </div>
    </div>
  </div>

  <div class="new-notifications">
    <p class="text-center" *ngIf="activeTab === 'unread' && unReadNotifications$().length === 0">
      {{"GENERAL.NO_UNREAD_MSG_FOUND" | translate}}
    </p>
    <div
      *ngFor="let notification of getNotifications(); let i = index"
      class="notification-item"
      [class.read]="notification.isReaded"
      (click)="markNotificationAsRead(notification.id)"
    >
      <div class="notification-content" [routerLink]="notification.getRouteUrl()">
        <h4>{{ notification?.title }}</h4>
        <p>{{ notification?.details }}</p>
        <small>{{ notification?.createdOn | date : 'short' }}</small>
      </div>
      <div class="notification-actions">
        <span
          *ngIf="!notification.isReaded"
          class="fa-solid fa-check"
          placement="top"
          ngbTooltip="Mark as read"
          (click)="markNotificationAsRead(notification.id)"
        ></span>
        <span
          *ngIf="notification.isReaded"
          class="fa-solid fa-times"
          placement="top"
          ngbTooltip="Delete this notification"
          (click)="clearNotification(notification.id)"
        ></span>
      </div>
    </div>
  </div>
</div>
